import React, { ReactElement } from "react"
import {
  ParcelRecipientContainer,
  ParcelRecipientName,
  ParcelRecipientTitle,
} from "components/Parcels/ParcelInfos.styled"
import ParcelRecipientSkeleton from "components/Parcels/ParcelSkeleton/ParcelRecipientSkeleton"
import { Order } from "types/order.types"
import { CarriersName } from "types/carrier.types"

interface ParcelSenderProps {
  order: Order
  loading: boolean
}

const SENDER_CLIENTS: string[] = [CarriersName.GEEV, CarriersName.POPPINS]

export const ParcelSender = ({ order, loading }: ParcelSenderProps): ReactElement | null => {
  if (loading) return <ParcelRecipientSkeleton />

  const clientName = order.__client__?.name
  if (!clientName || !SENDER_CLIENTS.includes(clientName)) return null

  const sender = order.sender
  if (!sender) return null

  const fullName = sender.name || [sender.firstName, sender.lastName].filter(Boolean).join(" ")
  const hasAnyField = fullName || sender.email || sender.phone
  if (!hasAnyField) return null

  return (
    <ParcelRecipientContainer>
      <ParcelRecipientTitle>▶️ Expéditeur</ParcelRecipientTitle>
      {fullName && <ParcelRecipientName>{fullName}</ParcelRecipientName>}
      {sender.phone && <div>{sender.phone}</div>}
      {sender.email && <div>{sender.email}</div>}
    </ParcelRecipientContainer>
  )
}

export default ParcelSender
